import { GridOperatorsState } from './grid-operator.models';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { createReducer, on } from '@ngrx/store';
import * as gridOperatorsActions from './grid-operator.actions';

export const gridOperatorsInitialState: GridOperatorsState = {
  gridOperators: [],
  gridOperatorsPage: null,
  gridOperatorsPagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  loading: false,
  error: null,
};

export const gridOperatorsReducer = createReducer(
  gridOperatorsInitialState,
  on(gridOperatorsActions.loadGridOperatorsList, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    gridOperatorsActions.loadGridOperatorsListSuccess,
    (state, { gridOperatorsResponse }) => ({
      ...state,
      loading: false,
      gridOperators: gridOperatorsResponse.result ?? [],
      gridOperatorsPage: {
        ...state.gridOperatorsPage,
        pageIndex: gridOperatorsResponse.pageIndex ?? 0,
        pageSize: gridOperatorsResponse.pageSize ?? 0,
        totalCount: gridOperatorsResponse.total ?? 0,
      },
    })
  ),
  on(gridOperatorsActions.loadGridOperatorsListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(
    gridOperatorsActions.changePagination,
    (state, { pageIndex, pageSize }) => ({
      ...state,
      gridOperatorsPagination: {
        pageIndex,
        pageSize,
      },
    })
  ),
  on(gridOperatorsActions.updateGridOperator, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    gridOperatorsActions.updateGridOperatorSuccess,
    (state, { gridOperator }) => ({
      ...state,
      loading: false,
      gridOperators: state.gridOperators.map((x) => {
        if (x.id == gridOperator.id) {
          return { ...gridOperator };
        }
        return x;
      }),
    })
  ),
  on(gridOperatorsActions.updateGridOperatorFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(gridOperatorsActions.createGridOperator, (state) => ({
    ...state,
    loading: true,
  })),
  on(gridOperatorsActions.createGridOperatorSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(gridOperatorsActions.createGridOperatorFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(gridOperatorsActions.deleteGridOperator, (state) => ({
    ...state,
    loading: true
  })),
  on(gridOperatorsActions.deleteGridOperatorSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(gridOperatorsActions.deleteGridOperatorFailure, (state) => ({
    ...state,
    loading: false
  }))
);
